module.exports = __webpack_public_path__ + "img/special_anonymous.f5305327.png";